import { useMemo } from 'react'
import * as THREE from 'three'

interface Props {
  raio?: number
  destaque?: boolean
  corDestaque?: string
}

/**
 * Cria a textura fotogramétrica característica de Crash-Test Dummy:
 * Círculo com 4 quadrantes alternados em amarelo (#eab308) e preto (#0f172a),
 * com cruzamento fino e ponto central de calibração.
 */
function gerarTexturaCrashTest(): THREE.CanvasTexture {
  const canvas = document.createElement('canvas')
  canvas.width = 128
  canvas.height = 128
  const ctx = canvas.getContext('2d')
  if (!ctx) return new THREE.CanvasTexture(canvas)

  const cx = 64
  const cy = 64
  const r = 60

  ctx.clearRect(0, 0, 128, 128)

  // Círculo base amarelo de segurança
  ctx.beginPath()
  ctx.arc(cx, cy, r, 0, Math.PI * 2)
  ctx.fillStyle = '#eab308'
  ctx.fill()

  // Quadrantes pretos (topo-esquerdo e baixo-direito)
  ctx.fillStyle = '#0f172a'

  // Quadrante 1: 0 a PI/2 (ou canto)
  ctx.beginPath()
  ctx.moveTo(cx, cy)
  ctx.arc(cx, cy, r, -Math.PI / 2, 0)
  ctx.closePath()
  ctx.fill()

  // Quadrante 3: PI a 3PI/2
  ctx.beginPath()
  ctx.moveTo(cx, cy)
  ctx.arc(cx, cy, r, Math.PI / 2, Math.PI)
  ctx.closePath()
  ctx.fill()

  // Borda externa preta
  ctx.beginPath()
  ctx.arc(cx, cy, r, 0, Math.PI * 2)
  ctx.strokeStyle = '#0f172a'
  ctx.lineWidth = 3
  ctx.stroke()

  // Linhas de mira cruzada
  ctx.beginPath()
  ctx.moveTo(cx - r, cy)
  ctx.lineTo(cx + r, cy)
  ctx.moveTo(cx, cy - r)
  ctx.lineTo(cx, cy + r)
  ctx.strokeStyle = '#0f172a'
  ctx.lineWidth = 2
  ctx.stroke()

  // Ponto central
  ctx.beginPath()
  ctx.arc(cx, cy, 3, 0, Math.PI * 2)
  ctx.fillStyle = '#eab308'
  ctx.fill()

  const texture = new THREE.CanvasTexture(canvas)
  texture.needsUpdate = true
  return texture
}

let texturaCompartilhada: THREE.CanvasTexture | null = null

function obterTexturaCrashTest(): THREE.Texture {
  if (!texturaCompartilhada && typeof document !== 'undefined') {
    texturaCompartilhada = gerarTexturaCrashTest()
  }
  return texturaCompartilhada ?? new THREE.Texture()
}

export function MarcadorCrashTest({
  raio = 0.038,
  destaque = false,
  corDestaque = '#ef4444',
}: Props) {
  const textura = useMemo(() => obterTexturaCrashTest(), [])

  return (
    <mesh>
      <circleGeometry args={[raio, 24]} />
      <meshStandardMaterial
        map={textura}
        roughness={0.4}
        metalness={0.1}
        emissive={destaque ? corDestaque : '#000000'}
        emissiveIntensity={destaque ? 0.75 : 0}
        side={THREE.DoubleSide}
      />
    </mesh>
  )
}
